export const apiUrl = process.env.REACT_APP_DOMAIN + "/rezervacie/api/v0.0"
//  yarn build && cd build && ln -s . frontend && cd ..